import React from 'react';
export function TalentGap() {
  return <section className="border-b border-ink/10 bg-cream py-12 sm:py-20" aria-labelledby="talento" data-id="element-140" data-mp="1jw5zjrvd7yz5">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-141" data-mp="136km7ueb7mlj">
        <div className="grid gap-6 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16" data-id="element-142" data-mp="1hue27g7b4r4n">
          <h2 id="talento" className="font-display text-[1.6rem] font-semibold leading-tight text-ink sm:text-4xl" data-id="element-143" data-mp="1d35quemf2vou">
            ¿Tenés el talento pero no el mapa para convertirlo en plata?
          </h2>
          <div className="space-y-4 text-[15px] leading-relaxed text-ink/75 sm:space-y-5 sm:text-lg" data-id="element-144" data-mp="1msz0vb6wv2qz">
            <p data-id="element-145" data-mp="20sqdp8loyd3e">
              La mayoría de las mujeres que quieren vivir de las uñas comete el mismo error:
              <span className="font-medium text-ink" data-id="element-146" data-mp="1vt5bmpb85omg"> aprenden la técnica, pero nadie les enseña el negocio.</span>
            </p>
            <p data-id="element-147" data-mp="6fibuwzat189">
              Entonces invierten en materiales, abren su Instagram, les hacen uñas a las amigas por
              casi nada y después de meses siguen sin poder dejar su trabajo. No porque les falte
              talento, sino porque nadie les dio el sistema completo.
            </p>
            <p className="border-l-2 border-champagne pl-4 text-ink sm:pl-5" data-id="element-148" data-mp="2cb8a3tbvw6w">
              En 2026 cambió todo. Las clientas no buscan el salón más lujoso de la ciudad. Buscan una
              artista experta que domine la técnica y les dé una experiencia VIP desde casa. Y eso,
              hoy, vale mucha plata.
            </p>
          </div>
        </div>
      </div>
    </section>;
}